import { render } from "./CustomRange.vue?vue&type=template&id=6af5c33d"
import script from "./CustomRange.vue?vue&type=script&lang=js"
export * from "./CustomRange.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__